export class FileObj {
  fileName: string;
  file: File;
  submitted: boolean = false;
}
